import { memo, useEffect, useState } from "react";
import styled from "styled-components";

const ClockContainer = styled.section`
  position: absolute;
  bottom: 0.1rem;
  right: 1rem;
  width: 7vmin;
  height: 7vmin;
  border-radius: 50%;
  z-index: 200;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(6px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: inset 2px 2px 6px rgba(0, 0, 0, 0.3),
    4px 4px 10px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  pointer-events: none;

  animation: fadeIn 0.6s ease-out;
`;

const CenterDot = styled.div`
  position: absolute;
  width: 0.5rem;
  height: 0.5rem;
  background: #000;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
`;

const fadeIn = `
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
`;

// Inject keyframe animation into the global stylesheet if needed
const StyleInjector = styled.div`
  ${fadeIn}
`;

const Hand = styled.div`
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform-origin: bottom center;
  transform: rotate(${(props) => props.angle}deg);
  background: #000;
  border-radius: 4px;
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.3);
`;

const HourHand = styled(Hand)`
  width: 0.3rem;
  height: 2rem;
  z-index: 3;
`;

const MinuteHand = styled(Hand)`
  width: 0.2rem;
  height: 3rem;
  z-index: 2;
`;

const SecondHand = styled(Hand)`
  width: 0.1rem;
  height: 3.4rem;
  background: red;
  z-index: 1;
`;

const AnalogClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours();

  return (
    <ClockContainer>
      <HourHand angle={(hours % 12) * 30 + minutes * 0.5} />
      <MinuteHand angle={minutes * 6 + seconds * 0.1} />
      <SecondHand angle={seconds * 6} />
      <CenterDot />
    </ClockContainer>
  );
};

export default memo(AnalogClock);
